import type { IconData } from '@stacksjs/iconify-core'

export const pictureF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m20 10.536l-4.416-4.44a3 3 0 0 0-4.69.582L5.072 16H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3zm-.011 2.724A3 3 0 0 1 17 16H7.64l4.969-8.293a1 1 0 0 1 1.563-.195zM6 9a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pictureF
